export default __webpack_public_path__ + "static/media/pajamas_status-health.e325c89c.svg";